import { useState } from 'react';

import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './Formulas.styles';

const media = (path: string) =>
  staticMediaUrl(`landing/bioderma-hydrabio/${path}`);

const blocks = [
  {
    id: 'wetting' as const,
    title: 'Длительное увлажнение',
    items: [
      {
        title: 'Высокомолекулярная гиалуроновая кислота',
        text: 'Сохраняет запасы влаги в коже'
      },
      {
        title: 'Технология активации увлажнения+',
        text: 'Помогает коже восстановить естественные механизмы увлажнения'
      }
    ]
  },
  {
    id: 'strengthening' as const,
    title: 'Укрепление кожного барьера',
    items: [
      {
        title: 'Ниацинамид',
        text: 'Помогает коже вырабатывать собственные липиды'
      },
      {
        title: 'Пробиотический сахар',
        text: 'Укрепляет здоровый микробиом кожи'
      }
    ]
  }
];

/** Формулы с двойным действием */
export function Formulas() {
  const [open, setOpen] = useState<'wetting' | 'strengthening' | null>(null);
  const slots = styles();

  return (
    <section
      id="formula"
      className={slots.base()}
    >
      <picture>
        <source
          srcSet={media('formulas/top-mobile.webp')}
          media="(max-width: 767px)"
        />
        <img
          className={slots.bgTop()}
          src={media('formulas/top-desktop.webp')}
          alt=""
        />
      </picture>
      <picture>
        <source
          srcSet={media('formulas/bottom-mobile.webp')}
          media="(max-width: 767px)"
        />
        <img
          className={slots.bgBottom()}
          src={media('formulas/bottom-desktop.webp')}
          alt=""
        />
      </picture>
      <video
        className={slots.video()}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source
          src={media('formulas/video.webm')}
          type="video/webm"
        />
        <source
          src={media('formulas/video.mp4')}
          type="video/mp4"
        />
      </video>
      <h2 className={slots.title()}>Формулы с двойным действием</h2>
      {blocks.map((block) => {
        const isOpen = open === block.id;
        const blockSlots = styles({ open: isOpen });

        return (
          <div
            key={block.id}
            className={blockSlots.block({
              className:
                block.id === 'wetting'
                  ? blockSlots.wetting()
                  : blockSlots.strengthening()
            })}
            onClick={() => {
              if (window.matchMedia('(min-width: 768px)').matches) return;
              setOpen(isOpen ? null : block.id);
            }}
          >
            <span className={blockSlots.hit()} />
            <p
              className={blockSlots.subtitle({
                className:
                  block.id === 'wetting'
                    ? blockSlots.subtitleWetting()
                    : blockSlots.subtitleStrengthening()
              })}
            >
              {block.title}
            </p>
            <span
              className={blockSlots.button({
                className:
                  block.id === 'wetting'
                    ? blockSlots.buttonWetting()
                    : blockSlots.buttonStrengthening()
              })}
            >
              <img
                className={blockSlots.buttonBg()}
                src={media('formulas/button.webp')}
                alt=""
              />
              <span className={blockSlots.buttonInner()}>
                <span className="md:hidden">
                  {isOpen ? <MinusIcon /> : <PlusIcon />}
                </span>
                <span className="hidden text-[#00BBDC] md:block md:group-hover:text-[#003A70]">
                  <PlusIcon />
                </span>
              </span>
            </span>
            <div className={blockSlots.content()}>
              <div className={blockSlots.contentInner()}>
                <ul className={blockSlots.list()}>
                  {block.items.map((item) => (
                    <li
                      key={item.title}
                      className={blockSlots.ingredient()}
                    >
                      <span className="absolute top-2.5 left-2 size-1 rounded-full bg-[#003A70]" />
                      <p className={blockSlots.ingredientTitle()}>
                        {item.title}
                      </p>
                      <p className={blockSlots.ingredientText()}>{item.text}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
}

function PlusIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      aria-hidden
      className="text-[#00BBDC] md:group-hover:text-[#003A70]"
    >
      <path
        d="M6 0v12M0 6h12"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}

function MinusIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      aria-hidden
      className="text-[#003A70]"
    >
      <path
        d="M0 6h12"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
